'use server'

import { Company } from '../common/interfaces/company.interface'
import { apiRequest, ApiResponse } from '../request'

export async function getCompanies(): Promise<ApiResponse<Company[]>> {
    return apiRequest<Company[]>('companies', {})
}

export async function getCompany(id: number): Promise<ApiResponse<Company>> {
    return apiRequest<Company>(`companies/${id}`, {}, 'get')
}

export interface CreateCompanyDto {
    name: string
    tradingName?: string
    cnpj?: string
    email?: string
    phone?: string
    website?: string
    logoUrl?: string
    street?: string
    number?: string
    complement?: string
    neighborhood?: string
    city?: string
    state?: string
    zipCode?: string
    organizationId?: number
}

export async function createCompany(data: CreateCompanyDto): Promise<ApiResponse<Company>> {
    return apiRequest<Company>('companies', { data }, 'post')
}

export async function updateCompany(
    id: number,
    data: {
        name?: string
        tradingName?: string
        cnpj?: string
        /** Documento da conta quando é de pessoa física (o CNPJ fica vazio). */
        cpf?: string
        stateRegistration?: string
        municipalRegistration?: string
        taxRegime?: string
        email?: string
        phone?: string
        website?: string
        aboutUs?: string
        street?: string
        number?: string
        complement?: string
        neighborhood?: string
        city?: string
        state?: string
        zipCode?: string
        country?: string
        bankCode?: string
        bankAgency?: string
        bankAccount?: string
        cityCode?: string
        pixKey?: string
        pixKeyType?: string
        serviceListItem?: string
        whatsappNumber?: string
        segment?: string
        secondarySegment?: string
    }
): Promise<ApiResponse<Company>> {
    return apiRequest<Company>(
        `companies/${id}`,
        {
            data,
        },
        'patch'
    )
}
